// src/lib/entitlement.js
// Single source of truth for Pro access on the client. Mirrors backend
// entitlement.is_pro_entitled. `user` is the users/{uid} Firestore doc data.
export function isProEntitled(user, now = new Date()) {
  if (!user) return false;
  if (user.role === 'Admin') return true;
  const e = user.entitlement;
  if (!e || e.tier !== 'Pro') return false;
  if (!e.expiresAt) return true;
  const exp = typeof e.expiresAt.toDate === 'function'
    ? e.expiresAt.toDate()
    : new Date(e.expiresAt);
  return exp.getTime() > now.getTime();
}
